import visaIcon from '@/assets/icons/payments/visa.svg';
import mastercardIcon from '@/assets/icons/payments/mastercard.svg';
import amexIcon from '@/assets/icons/payments/amex.svg';
import discoverIcon from '@/assets/icons/payments/discover.svg';
import unionpayIcon from '@/assets/icons/payments/unionpay.svg';
import creditCardIcon from '@/assets/icons/payments/credit-card.svg';
import diners from '@/assets/icons/payments/diners.png';
import type { SavedCard } from '@/types/checkout';
import { ProviderEnum } from '@/types/common';

export const getCardBrandByProvider = (provider: ProviderEnum, card: SavedCard) => {
  switch (provider) {
    case ProviderEnum.ADYEN:
      return card.isNew ? (card.paymentMethodData?.brand as string)?.toLowerCase() : card.brand?.toLowerCase();
    case ProviderEnum.STRIPE:
      return card.brand?.toLowerCase();
    case ProviderEnum.NUVEI:
      return card.isNew ? card.cardDetails?.brand?.toLowerCase() : card.brand?.toLowerCase();
    case ProviderEnum.BRAINTREE:
      return card.brand?.toLowerCase();
    default:
      return card.brand?.toLowerCase();
  }
};

export const getCardBrandIcon = (cardType: string | undefined): string => {
  if (!cardType) return creditCardIcon;

  const cardTypeMap: Record<string, string> = {
    visa: visaIcon,
    mastercard: mastercardIcon,
    'master-card': mastercardIcon,
    mc: mastercardIcon,
    'american-express': amexIcon,
    amex: amexIcon,
    discover: discoverIcon,
    unionpay: unionpayIcon,
    'union-pay': unionpayIcon,
    diners: diners,
  };

  return cardTypeMap[cardType.toLowerCase()] ?? creditCardIcon;
};
